import axios from "axios";
import { create } from "zustand";
import categoryStore from "./categoryStore";

const productStore = create((set) => ({
  mProduct: null,
  product: null,
  isLoading: false,
  MAX_FILE_SIZE: 1500,
  _id: null,
  imagesPreview: [],
  imageFiles: [],

  isSaleLabel: false,
  isNewLabel: false,
  productCategoryName: "",

  M: false,
  W: false,
  K: false,

  clearProductID: () => {
    set({ _id: null });
  },

  productFilterApply: 0,

  setProductFilterApply: ({ value }) => {
    set({ productFilterApply: value });
  },

  productForm: {
    productName: "",
    productSubDescription: "",
    productContent: "",
    productImages: [],
    productCode: "",
    productSKU: "",
    howManyColor: "",
    categoryID: "",
    productColors: [],
    productSizes: [],
    gender: [],
    tagID: [],
    deliverDays: "",
    currentStock: "",
    productSaleLabel: "",
    productNewLabel: "",
    regularPrice: "",
    salePrice: "",
    includesTaxes: true,
    tax: "",
    publish: true,
    updated_at: Date.now,
  },

  validateProductForm: {
    productName: false,
    productContent: false,
    productImages: false,
    howManyColor: false,
    categoryID: false,
    gender: false,
    tagID: false,
    deliverDays: false,
    currentStock: false,
    productSaleLabel: false,
    productNewLabel: false,
    regularPrice: false,
    tax: false,
  },

  setSwitchOnOrOff: ({ name, value }) => {
    set({ [name]: value });
    if (name === "isSaleLabel") {
      set((state) => {
        return {
          productForm: {
            ...state.productForm,
            productSaleLabel: "",
          },
        };
      });
      set((state) => {
        return {
          validateProductForm: {
            ...state.validateProductForm,
            productSaleLabel: false,
          },
        };
      });
    }
    if (name === "isNewLabel") {
      set((state) => {
        return {
          productForm: {
            ...state.productForm,
            productNewLabel: "",
          },
        };
      });
      set((state) => {
        return {
          validateProductForm: {
            ...state.validateProductForm,
            productNewLabel: false,
          },
        };
      });
    }
    if (name === "publish") {
      set((state) => {
        return {
          productForm: {
            ...state.productForm,
            publish: value,
          },
        };
      });
    }
  },

  setIncludesTaxes: ({ value }) => {
    set((state) => {
      return {
        productForm: {
          ...state.productForm,
          includesTaxes: value,
          tax: "",
        },
      };
    });
  },

  fillProductContent: ({ value }) => {
    set((state) => {
      return {
        productForm: {
          ...state.productForm,
          productContent: value,
        },
      };
    });
  },

  fillProductDataWithName: (e) => {
    const { name, value } = e.target;
    set((state) => {
      return {
        productForm: {
          ...state.productForm,
          [name]: value,
        },
      };
    });
  },

  fillCategoryID: ({ id }) => {
    set((state) => {
      return {
        productForm: {
          ...state.productForm,
          categoryID: id,
        },
      };
    });
  },

  fillProductDataWithAutoCompleteMultiple: ({ name, value }) => {
    set((state) => {
      return {
        productForm: {
          ...state.productForm,
          [name]: value,
        },
      };
    });
  },

  fillProductImage: async ({ files }) => {
    const {
      convertToBase64,
      MAX_FILE_SIZE,
      imagesPreview,
      imageFiles,
      productForm: { productImages },
    } = productStore.getState();
    const data = productImages ? [...productImages] : [];
    const image = imagesPreview ? [...imagesPreview] : [];
    const imgFile = imageFiles ? [...imageFiles] : [];

    for (let i = 0; i < files.length; i++) {
      // if (MAX_FILE_SIZE < files[i].size / 1024) continue;
      // const base64 = await convertToBase64(files[i]);
      // data.push(base64);
      data.push(files[i].name);
      imgFile.push(files[i]);
      image.push(URL.createObjectURL(files[i]));
    }

    set((state) => {
      return {
        productForm: {
          ...state.productForm,
          productImages: data,
        },
      };
    });
    set({ imagesPreview: image, imageFiles: imgFile });
    return true;
  },

  convertToBase64: (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  },

  removeProductImage: ({
    removeItem = null,
    removeImagePreview = null,
    removeFiles = null,
  }) => {
    const {
      productForm: { productImages },
      imagesPreview,
      imageFiles,
    } = productStore.getState();

    const data = productImages.filter((item) => {
      if (removeItem == null) {
        return item !== removeFiles.name;
      }
      return item !== removeItem;
    });

    const image = imagesPreview.filter((item) => {
      return item !== removeImagePreview;
    });

    const imgFile = imageFiles.filter((item) => {
      return item !== removeFiles;
    });

    set((state) => {
      return {
        productForm: {
          ...state.productForm,
          productImages: data ? data : [],
        },
      };
    });

    set({
      imagesPreview: image ? image : [],
      imageFiles: imgFile ? imgFile : [],
    });
  },

  pushGender: ({ value }) => {
    const {
      productForm: { gender },
    } = productStore.getState();
    const data = gender ? [...gender] : [];
    data.push(value);

    set({ [value]: true });

    set((state) => {
      return {
        productForm: {
          ...state.productForm,
          gender: data ? data : [],
        },
      };
    });
  },

  popGender: ({ value }) => {
    const {
      productForm: { gender },
    } = productStore.getState();

    const data = gender.filter((item) => {
      return item !== value;
    });

    set({ [value]: false });

    set((state) => {
      return {
        productForm: {
          ...state.productForm,
          gender: data ? data : [],
        },
      };
    });
  },

  checkValidation: ({ name, value }) => {
    set((state) => {
      return {
        validateProductForm: {
          ...state.validateProductForm,
          [name]: value,
        },
      };
    });
  },

  clearProductForm: () => {
    set({
      productForm: {
        productName: "",
        productSubDescription: "",
        productContent: "",
        productImages: [],
        productCode: "",
        productSKU: "",
        howManyColor: "",
        categoryID: "",
        productColors: [],
        productSizes: [],
        gender: [],
        tagID: [],
        deliverDays: "",
        currentStock: "",
        productSaleLabel: "",
        productNewLabel: "",
        regularPrice: "",
        salePrice: "",
        includesTaxes: true,
        tax: "",
        publish: true,
      },
    });
    set({
      isSaleLabel: false,
      isNewLabel: false,
      productCategoryName: "",

      imagesPreview: [],
      imageFiles: [],

      M: false,
      W: false,
      K: false,
    });

    set({
      validateProductForm: {
        productName: false,
        productContent: false,
        productImages: false,
        howManyColor: false,
        categoryID: false,
        gender: false,
        tagID: false,
        deliverDays: false,
        currentStock: false,
        productSaleLabel: false,
        productNewLabel: false,
        regularPrice: false,
        tax: false,
      },
    });
  },

  createProduct: async () => {
    const { productForm, clearProductForm, imageFiles } =
      productStore.getState();

    var productFormData = new FormData();
    productFormData.append("productName", productForm.productName);
    productFormData.append(
      "productSubDescription",
      productForm.productSubDescription
    );
    productFormData.append("productContent", productForm.productContent);

    for (let i = 0; i < imageFiles.length; i++) {
      productFormData.append("proImages", imageFiles[i]);
    }

    for (let i = 0; i < productForm.productImages.length; i++) {
      productFormData.append("productImages", productForm.productImages[i]);
    }

    productFormData.append("productCode", productForm.productCode);
    productFormData.append("productSKU", productForm.productSKU);
    productFormData.append("howManyColor", productForm.howManyColor);
    productFormData.append("categoryID", productForm.categoryID);
    if (productForm.productColors.length) {
      for (let i = 0; i < productForm.productColors.length; i++) {
        productFormData.append("productColors", productForm.productColors[i]);
      }
    } else {
      productFormData.append("productColors", []);
    }
    if (productForm.productSizes.length) {
      for (let i = 0; i < productForm.productSizes.length; i++) {
        productFormData.append("productSizes", productForm.productSizes[i]);
      }
    } else {
      productFormData.append("productSizes", []);
    }
    if (productForm.gender.length) {
      for (let i = 0; i < productForm.gender.length; i++) {
        productFormData.append("gender", productForm.gender[i]);
      }
    } else {
      productFormData.append("gender", []);
    }
    if (productForm.tagID.length) {
      for (let i = 0; i < productForm.tagID.length; i++) {
        productFormData.append("tagID", productForm.tagID[i]);
      }
    } else {
      productFormData.append("tagID", []);
    }
    productFormData.append("deliverDays", productForm.deliverDays);
    productFormData.append("currentStock", productForm.currentStock);
    productFormData.append("productSaleLabel", productForm.productSaleLabel);
    productFormData.append("productNewLabel", productForm.productNewLabel);
    productFormData.append("regularPrice", productForm.regularPrice);
    productFormData.append("salePrice", productForm.salePrice);
    productFormData.append("includesTaxes", productForm.includesTaxes);
    productFormData.append("tax", productForm.tax);
    productFormData.append("publish", productForm.publish);
    productFormData.append("updated_at", productForm.updated_at);

    // Create the Product
    const res = await axios.post("/create-product", productFormData);

    if (res) {
      clearProductForm();
      return true;
    } else {
      return false;
    }
  },

  fetchAllProduct: async () => {
    // Fetch product
    const res = await axios.get("/fetch-all-product");
    // set product to state
    set({ product: res.data.product, mProduct: res.data.product });
    set({ isLoading: false });
  },

  fillUpdateProduct: ({ _id }) => {
    const { mProduct } = productStore.getState();
    if (mProduct === null) return false;
    const data = mProduct.find((item) => {
      return item._id === _id && item;
    });
    data.productSaleLabel !== "" && set({ isSaleLabel: true });
    data.productNewLabel !== "" && set({ isNewLabel: true });
    set({ _id: _id });
    set({
      productForm: {
        productName: data.productName,
        productSubDescription: data.productSubDescription,
        productContent: data.productContent,
        productImages: data.productImages,
        productCode: data.productCode,
        productSKU: data.productSKU,
        howManyColor: data.howManyColor,
        categoryID: data.categoryID,
        productColors: data.productColors && data.productColors,
        productSizes: data.productSizes,
        gender: data.gender,
        tagID: data.tagID,
        deliverDays: data.deliverDays,
        currentStock: data.currentStock,
        productSaleLabel: data.productSaleLabel,
        productNewLabel: data.productNewLabel,
        regularPrice: data.regularPrice,
        salePrice: data.salePrice ? data.salePrice : "",
        includesTaxes: data.includesTaxes,
        tax: data.tax ? data.tax : "",
        publish: data.publish,
      },
    });
    data.gender.map((g) => set({ [g]: true }));
    const { category } = categoryStore.getState();
    category.map(
      (item) =>
        item._id === data.categoryID &&
        set({ productCategoryName: item.categoryName })
    );
  },

  updateProduct: async () => {
    try {
      const { clearProductForm, clearProductID, _id, productForm, imageFiles } =
        productStore.getState();

      var productFormData = new FormData();
      productFormData.append("productName", productForm.productName);
      productFormData.append(
        "productSubDescription",
        productForm.productSubDescription
      );
      productFormData.append("productContent", productForm.productContent);

      for (let i = 0; i < imageFiles.length; i++) {
        productFormData.append("proImages", imageFiles[i]);
      }

      for (let i = 0; i < productForm.productImages.length; i++) {
        productFormData.append("productImages", productForm.productImages[i]);
      }

      productFormData.append("productCode", productForm.productCode);
      productFormData.append("productSKU", productForm.productSKU);
      productFormData.append("howManyColor", productForm.howManyColor);
      productFormData.append("categoryID", productForm.categoryID);
      if (productForm.productColors.length) {
        for (let i = 0; i < productForm.productColors.length; i++) {
          productFormData.append("productColors", productForm.productColors[i]);
        }
      } else {
        productFormData.append("productColors", []);
      }
      if (productForm.productSizes.length) {
        for (let i = 0; i < productForm.productSizes.length; i++) {
          productFormData.append("productSizes", productForm.productSizes[i]);
        }
      } else {
        productFormData.append("productSizes", []);
      }
      if (productForm.gender.length) {
        for (let i = 0; i < productForm.gender.length; i++) {
          productFormData.append("gender", productForm.gender[i]);
        }
      } else {
        productFormData.append("productSizes", []);
      }
      if (productForm.tagID.length) {
        for (let i = 0; i < productForm.tagID.length; i++) {
          productFormData.append("tagID", productForm.tagID[i]);
        }
      } else {
        productFormData.append("productSizes", []);
      }
      productFormData.append("deliverDays", productForm.deliverDays);
      productFormData.append("currentStock", productForm.currentStock);
      productFormData.append("productSaleLabel", productForm.productSaleLabel);
      productFormData.append("productNewLabel", productForm.productNewLabel);
      productFormData.append("regularPrice", productForm.regularPrice);
      productFormData.append("salePrice", productForm.salePrice);
      productFormData.append("includesTaxes", productForm.includesTaxes);
      productFormData.append("tax", productForm.tax);
      productFormData.append("publish", productForm.publish);
      productFormData.append("updated_at", Date.now());

      // send to update request
      const res = await axios.put(`/update-product/${_id}`, productFormData);

      if (res) {
        set({ product: res.data.product, mProduct: res.data.product });
        set({ isLoading: false });
      }

      // update state
      clearProductForm();
      clearProductID();
      return true;
    } catch (error) {
      console.log("error: ", error);
    }
  },

  updateProductPublish: async ({ _id, publish }) => {
    const { mProduct } = productStore.getState();
    const res = await axios.put(`/update-product-publish/${_id}`, { publish });

    const newProduct = [...mProduct];
    const productIndex = mProduct.findIndex((p) => {
      return p._id === _id;
    });
    newProduct[productIndex].publish = publish;

    set({
      product: newProduct,
      mProduct: newProduct,
    });
    if (res.data.result === 1) {
      return true;
    }
  },
}));

export default productStore;
